import React from "react";
import { useTranslation } from "react-i18next";
import NoResult from "components/Datatable/NoResult/NoResult";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import s from "./SubTable.module.scss";

const SubTable = ({
  columns,
  datasource,
  sortFn,
  customSortOrder,
  displayRowMerchantId,
  isEditing,
  subTableAddBtn,
  handleSubtableAddFn,
  isAdding,
  addMdrValue,
  handleAddMdrOnchange,
  handleAddMdrOnBlur,
  getCardTypeOptions,
}) => {
  const { t } = useTranslation();

  let sortedSubtableContent = [];

  if (datasource && customSortOrder) {
    //sort subtable data according to sortOrder array
    const result = [
      ...[
        ...datasource.filter((e) => customSortOrder.includes(e?.cardType)),
      ].sort((a, b) => {
        return (
          customSortOrder.indexOf(a?.cardType) -
          customSortOrder.indexOf(b?.cardType)
        );
      }),
      ...datasource.filter((e) => !customSortOrder.includes(e?.cardType)),
    ];
    sortedSubtableContent = result;
  } else if (datasource && sortFn) {
    //sort subtable data according to sortFn accessor function
    sortedSubtableContent = [...datasource].sort((a, b) => {
      if (typeof sortFn(a) === "string") {
        return sortFn(a).localeCompare(sortFn(b));
      } else {
        return sortFn(a) - sortFn(b);
      }
    });
  } else {
    sortedSubtableContent = datasource;
  }

  const newMdrRow = (column, key, data) => {
    return (
      <div
        className={[
          s.td,
          column.type && column.type === "amount" ? s.alignRight : "",
        ].join(" ")}
      >
        {key === "cardType" ? (
          <div className={s.content}>
            <select
              value={addMdrValue[displayRowMerchantId][key]}
              onChange={(e) =>
                handleAddMdrOnchange(e.target.value, displayRowMerchantId, key)
              }
              onBlur={(e) =>
                handleAddMdrOnBlur(e.target.value, displayRowMerchantId, key)
              }
            >
              <option value={""}></option>
              {getCardTypeOptions(data)}
            </select>
          </div>
        ) : key === "action" ? (
          <div>{column.renderAdd(displayRowMerchantId)}</div>
        ) : (
          <div className={s.content}>
            <input
              type="text"
              style={{ maxWidth: "80px" }}
              value={addMdrValue[displayRowMerchantId][key]}
              onChange={(e) =>
                handleAddMdrOnchange(e.target.value, displayRowMerchantId, key)
              }
              onBlur={(e) =>
                handleAddMdrOnBlur(e.target.value, displayRowMerchantId, key)
              }
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <table className={s.subTable}>
        <thead>
          <tr>
            {columns.map((column) => {
              return (
                <th key={column.key}>
                  <div
                    className={[
                      s.header,
                      column.type && column.type === "amount"
                        ? s.alignRight
                        : "",
                      column.key === "action" ? s.actionHeader : "",
                    ].join(" ")}
                  >
                    <div className={s.title}>
                      {column.title}
                      {column.indicator && <sup>{column.indicator}</sup>}
                    </div>
                  </div>
                </th>
              );
            })}
            <th style={{ width: "100%" }}></th>
          </tr>
        </thead>
        <tbody>
          {sortedSubtableContent.length !== 0 && (
            <>
              {sortedSubtableContent.map((data, index) => {
                return (
                  <tr key={index} className={s.tr}>
                    {columns.map((column) => {
                      const k = column.key;
                      return (
                        <td key={k}>
                          <div
                            className={[
                              s.td,
                              column.type && column.type === "amount"
                                ? s.alignRight
                                : "",
                            ].join(" ")}
                          >
                            {isEditing &&
                            isEditing[data.id] &&
                            column.renderEdit ? (
                              k === "cardType" ? (
                                <div className={s.content}>
                                  {column.renderEdit(
                                    data,
                                    k,
                                    sortedSubtableContent,
                                  )}
                                </div>
                              ) : (
                                <div className={s.content}>
                                  {column.renderEdit(data, k)}
                                </div>
                              )
                            ) : (
                              <div className={s.content}>
                                {column.render(data, k)}
                              </div>
                            )}
                          </div>
                        </td>
                      );
                    })}
                    <td style={{ width: "100%" }}></td>
                  </tr>
                );
              })}
            </>
          )}
          {isAdding && isAdding[displayRowMerchantId] && (
            <tr>
              {columns.map((column) => {
                const k = column.key;
                return (
                  <td key={k}>{newMdrRow(column, k, sortedSubtableContent)}</td>
                );
              })}
              <td style={{ width: "100%" }}></td>
            </tr>
          )}
        </tbody>
      </table>
      {sortedSubtableContent.length === 0 && !isAdding && <NoResult />}
      {subTableAddBtn && (
        <div className={s.addRowBtnContainer}>
          <ButtonMAS onClick={() => handleSubtableAddFn(displayRowMerchantId)}>
            {t("component.subtable.add")}
          </ButtonMAS>
        </div>
      )}
    </>
  );
};

export default React.memo(SubTable);
